import React, { useEffect, useState, useContext } from 'react'
import { decryptString } from '../../../../services/crypto'
import jwtDecode from 'jwt-decode'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import ReportGmailerrorredOutlinedIcon from '@mui/icons-material/ReportGmailerrorredOutlined'
import { AuthContext } from '../../../../contexts/Auth'
import { api } from '../../../../services/api'
import { saveHistoryAccess } from '../../../../services/saveHistoryAccess'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const ErrorModal = (props) => {
  const { logoutSystem } = useContext(AuthContext)
  const [isMobile, setIsMobile] = useState(decryptString('isMobile'))
  const [open, setOpen] = useState(props.openModal)
  const [token, setToken] = useState(null)

  useEffect(() => {
    const _token = localStorage.getItem('token')

    if (_token) {
      setToken(_token)
      api.defaults.headers.Authorization = `Bearer ${token}`
    } else {
      const infoToken = jwtDecode(_token)
      saveHistoryAccess(infoToken.userId, 'Logout', 'logout', '', '')
      logoutSystem('')
    }
    // eslint-disable-next-line
  }, [])

  const handleClose = () => {
    props.setOpenErrorModal(false)
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      /* disableBackdropClick */
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          // Set 'open' to false, however you would do that with your particular code.
          setOpen(false)
        }
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <div className="icon-dialog">
          <ReportGmailerrorredOutlinedIcon className="icon-error-dialog" />
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText component={'span'}>
          {!isMobile && (
            <div className="content-dialog-column">
              <span className="content-dialog-title-error">Atenção!</span>
              <span>{props.message}</span>
            </div>
          )}
          {isMobile && (
            <div className="content-dialog-column-mobile">
              <span className="content-dialog-title-error">Atenção!</span>
              <span>{props.message}</span>
            </div>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className="btn-dialog">
          <button
            type="button"
            className="btn-blue"
            onClick={(e) => {
              if (props.logout) {
                const infoToken = jwtDecode(token)
                saveHistoryAccess(infoToken.userId, 'Logout', 'logout', '', '')
                logoutSystem('')
              } else {
                handleClose(e)
              }
            }}
          >
            OK
          </button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default ErrorModal
